import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Heading,
  Modal,
  ModalBody,
  ModalHeader,
} from '@americanexpress/dls-react';
import { MODULE_NAME } from '../../constants/globalConstants';

const TRAVELER_INFO_MODAL_HEADER_ID = 'searchCloseTravelers';
const TRAVELER_INFO_MODAL_BODY_ID = `${MODULE_NAME}-traveler-info-modal-body`;

const TravelerInfoModal = ({ shown, onClose }) => {
  const { formatMessage } = useIntl();

  return (
    shown && (
      <Modal
        aria-labelledby={TRAVELER_INFO_MODAL_HEADER_ID}
        aria-describedby={TRAVELER_INFO_MODAL_BODY_ID}
        id="hotelTravelerModal"
        onClose={onClose}
      >
        <ModalHeader id={TRAVELER_INFO_MODAL_HEADER_ID}>
          <Heading
            level={2}
          >
            {formatMessage({ id: 'modal.travelers' })}
          </Heading>
        </ModalHeader>
        <ModalBody id={TRAVELER_INFO_MODAL_BODY_ID}>
          <section className="margin-2-b">
            <Heading level={3} className="heading-2">
              {formatMessage({ id: 'modal.adult' })}
            </Heading>
            <p>
              <FormattedMessage id="modal.adult_age_range" />
            </p>
          </section>
          <section>
            <Heading level={3} className="heading-2">
              {formatMessage({ id: 'modal.child' })}
            </Heading>
            <p>
              <FormattedMessage id="modal.child_age_range" />
              <br />
              <FormattedMessage id="modal.must_be_one_adult" />
            </p>
          </section>
        </ModalBody>
      </Modal>
    )
  );
};

TravelerInfoModal.propTypes = {
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { TravelerInfoModal as TestableTravelerInfoModal };

export default TravelerInfoModal;
